<template>
  <div v-if="brandImages && brandImages.length" class="vehicle_brand_images mb-4">
    <VSlickCarousel ref="slick" v-bind="slickOptions">
      <template #nextArrow="arrowSlotProps">
        <em :disabled="arrowSlotProps.disabled" @click="arrowSlotProps.onClick" class="primaryicon-right-arrow"
          :style="getArrowStyles('right')"></em>
      </template>
      <div v-for="(item, index) in brandImages" :key="index" class="p-1">
        <div
          class="vehicle_brand_images_card h-100  text-center cursor_pointer  rounded_20  align-items-center p-1 py-2"
          :style="[index === isChecked ? { border: '1px solid' + primaryColor } : { border: '0px solid #fff' }]"
          :class="[{ disabledContent: !isLastIndex }, { 'custom_box_shadow bg-white': !isGradient }, { 'transparent-bgcolor-light': isGradient }]"
          @click.once="eachBrand(item, index)">
          <img :src="imgBasePath + item.imageName" class="img-fluid rounded_10" :alt="item.make" />
        </div>
      </div>
      <template #prevArrow="arrowSlotProps">
        <em :disabled="arrowSlotProps.disabled" @click="arrowSlotProps.onClick" class="primaryicon-left-arrow"
          :style="getArrowStyles('left')"></em>
      </template>
    </VSlickCarousel>
  </div>
</template>
<script>
import 'v-slick-carousel/style.css';
import { VSlickCarousel } from 'v-slick-carousel';
import { ChatWidgetService } from '../../../../Services/ChatWidgetService/ChatWidgetService';
export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ['botResponse', 'isLastIndex', 'chatThemeSettings', 'isNewDesign'],
  data() {
    return {
      brandImages: [],
      primaryColor: window.primaryColor,
      isChecked: null,
      transparentColor: '',
      textColor: '#000',
      slickOptions: {
        infinite: false,
        groupsToShow: 6,
        groupsToScroll: 1,
        slidesPerGroup: 2,
        dots: false,
        infiniteLoopOnEdge: true,
      },
    }
  },

  mounted() {

    if (this.botResponse?.component?.value?.images?.length) {
      this.brandImages = this.botResponse.component.value.images;
    }
    if (this.chatThemeSettings?.primeColor) {
      this.primaryColor = this.chatThemeSettings.primeColor;
    }

    if (this.isGradient) {
      this.primaryColor = '#fff';
    }

  },
  methods: {
    eachBrand(item, index) {
      let specialObject = { TvmComponentRequest: item };
      ChatWidgetService.postTvmMessage(item.make, null, this.botResponse?.component?.submitFlow,
        this.botResponse?.component?.submitAction, specialObject);
      this.isChecked = index;
    },
    getArrowStyles(direction) {
      const commonStyles = {
        cursor: 'pointer',
        top: '50%',
        transform: 'translateY(-50%)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor:
          this.isNewDesign && this.isGradient
            ? 'rgba(0,0,0,0.4) !important'
            : this.primaryColor,
        color: '#fff',
        fontSize: this.isNewDesign ? '16px' : '10px',
        padding: this.isNewDesign ? '15px !important' : '5px',
        zIndex: 10,
        height: this.isNewDesign ? '96%' : 'auto',
        borderRadius: this.isNewDesign ? '10px' : '0px 3px 3px 0px',
      };
      if (direction === 'left') {
        return {
          ...commonStyles,
          left: this.isNewDesign ? '-40px !important' : '0',
          borderRadius: this.isNewDesign ? '3px' : '0px 3px 3px 0px',
        };
      } else if (direction === 'right') {
        return {
          ...commonStyles,
          right: this.isNewDesign ? '-40px !important' : '0',
          borderRadius: this.isNewDesign ? '3px' : '3px 0px 0px 3px',
        };
      }
      return commonStyles;
    },

  },
  computed: {
    isGradient() {
      return this.chatThemeSettings?.isGradient || false;
    },
    imgBasePath() {
      return this.botResponse?.component?.value?.imageBaseUri || ''
    }
  },
  components: {
    VSlickCarousel
  },

}
</script>
<style lang="less" scoped>
.vehicle_brand_images {
  // gap: 15px;
  // display: grid;
  // grid-template-columns: repeat(6, 1fr);

  .rounded_20 {
    border-radius: 20px;
  }
}

.vehicle_brand_images_card {

  min-height: 135px;
  display: flex;
  align-items: center;
  justify-content: center;

  &.disabledContent {
    pointer-events: none !important;
    opacity: 0.9 !important;
  }

  .rounded_20 {
    border-radius: 20px;
  }

  .cursor_pointer {
    cursor: pointer;
  }




}
</style>
